/**
 * User Role Detection Hooks
 * Helpers to determine user roles and permissions
 */

import { useAppSelector } from './redux';

/**
 * Check if current user is a Delivery user
 * Based on role name from user profile
 */
export const useIsDeliveryUser = (): boolean => {
  const roleName = useAppSelector((state) => state.auth.user?.role);
  return roleName?.toLowerCase() === 'delivery';
};

/**
 * Check if current user has a specific role
 */
export const useHasRole = (roleName: string): boolean => {
  const userRoleName = useAppSelector((state) => state.auth.user?.role);
  return userRoleName?.toLowerCase() === roleName.toLowerCase();
};

/**
 * Get current user's role name
 */
export const useUserRole = (): string | null => {
  return useAppSelector((state) => state.auth.user?.role || null);
};
